import { Link, MoreHorizontal, Trash2 } from "react-feather";
import { CardBody, Table } from "reactstrap";
import SweetAlert from "sweetalert2";
import { useAppDispatch, useAppSelector } from "../../Redux-Toolkit/Hooks";
import { removeTask } from "../../Redux-Toolkit/Reducers/TaskSlice";
import { Href } from "../../Constant";
import { H4, P } from "../../AbstractElements";

const CreatedByme = () => {
  const { allTask } = useAppSelector((state) => state.task);
  const dispatch = useAppDispatch();

  const deleteTask = (userId: number) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        dispatch(removeTask(userId));
        SweetAlert.fire("Deleted!", "Your file has been deleted.", "success");
      } else {
        SweetAlert.fire("Your imaginary file is safe!");
      }
    });
  };

  return (
    <CardBody className="p-0">
      <div className="taskadd">
        <div className="table-responsive theme-scrollbar table-borderless">
          <Table borderless>
            <thead>
              <tr></tr>
            </thead>
            <tbody>
              {allTask && allTask.length ? (
                allTask.map((tasklistdata, index) => (
                  <tr key={index}>
                    <td>
                      <H4 className="task_title_0">{tasklistdata.title}</H4>
                      <P className="project_name_0">{tasklistdata.collection}</P>
                    </td>
                    <td><P className="task_desc_0">{tasklistdata.description}</P></td>
                    <td>
                      <a className="me-2" href={Href}><Link /></a>
                      <a href={Href}><MoreHorizontal /></a>
                    </td>
                    <td>
                      <a href={Href} onClick={() => deleteTask(tasklistdata.id)}><Trash2 /></a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>
                    <div className="no-favourite">
                      <span>No Tasks Found</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </CardBody>
  );
};

export default CreatedByme;
